var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressEmpty = function SvgAddressEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4588_24281)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#F5F4EE",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M94 19v22m11-11H83"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4588_24281)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BF1424",
    d: "m26.982 106.095.594.106-.4.613a11.7 11.7 0 0 0-1.842 5.42 11.8 11.8 0 0 0 .968 5.654 12.2 12.2 0 0 0 3.564 4.583 12.55 12.55 0 0 0 5.322 2.469c1.94.377 3.975.308 5.863-.219a12.34 12.34 0 0 0 5.063-2.864 11.7 11.7 0 0 0 3.086-4.841c.602-1.828.74-3.8.405-5.706l-.183-1.031 29.272 5.226-.529.903a11.7 11.7 0 0 0-1.613 5.431 11.9 11.9 0 0 0 1.152 5.568c.84 1.729 2.099 3.264 3.652 4.435 3.122 2.344 7.414 3.111 11.139 1.988a12.2 12.2 0 0 0 4.961-2.897 11.7 11.7 0 0 0 3.007-4.825c.585-1.817.72-3.774.366-5.654l-.184-1.031 1.916.343a3.63 3.63 0 0 0 2.675-.565 3.46 3.46 0 0 0 1.473-2.24l2.963-16.598c.09-.506.035-1.052-.121-1.556a3.5 3.5 0 0 0-.813-1.367l-.015-.002L91.59 78.294l2.195-12.297c.452-1.93.546-3.06-.423-4.5-.41-.624-1.62-1.912-3.562-2.363l-50.597-9.137c-1.936-.226-3.945-.734-5.652.242-.513.296-1.901 1.463-2.152 3.384l-7.29 41.012c-.052.288-.17.774-.636 3.386-.518 2.902-1.495 7.344 3.494 8.071zm14.828 11.97a5.99 5.99 0 0 1-6.448 1.351 5.97 5.97 0 0 1-2.722-2.094 5.7 5.7 0 0 1-1.083-3.202 5.64 5.64 0 0 1 .914-3.233c.907-1.387 2.392-2.328 4.142-2.597 1.905-.285 3.895.413 5.212 1.795s1.864 3.207 1.544 4.997a5.6 5.6 0 0 1-1.56 2.983m37.113-9.594-48.446-8.648 7.665-42.94L86.59 65.53zm14.244 18.762a6 6 0 0 1-3.005 1.638 6.1 6.1 0 0 1-2.32.033 6 6 0 0 1-1.123-.32 5.96 5.96 0 0 1-2.722-2.094 5.7 5.7 0 0 1-1.083-3.202 5.64 5.64 0 0 1 .914-3.233c1.032-1.573 2.788-2.57 4.826-2.653a5.85 5.85 0 0 1 4.028 1.389c1.663 1.414 2.4 3.467 2.044 5.459a5.6 5.6 0 0 1-1.56 2.983m8.416-14.177-15.59-3.323 4.042-22.646 13.606 14.436z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4588_24281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#fff",
    rx: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4588_24281"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.267 48.76 83.957 14.987-13.09 73.323-83.956-14.988z"
  })))));
};
export default SvgAddressEmpty;